import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    monthReportICDPasien: moment().format('MM'),
    rangeTglKunjunganPasien: [],
    reportKunjunganPasien: {
        legendaDays: "",
        totalSemuaPasien: "",
        totalPasienBerhasil: "",
        totalPasienBatal: "",
    },
    reportICDPasien: {
        listICDCode: [],
        listICDCode: [],
        listICDName: [],
    },
    formDetailRekamMedis: {
        dataRekamMedis: {
            f_id_rekam_medis: "",
            f_kode_rekam_medis: "",
            f_tgl_buat: "",
            f_nama_poliklinik: "",
            f_nama_dokter: "",
            f_nama_pasien: "",
            f_no_identitas: "",
            f_diagnosa_icd: "",
            f_kode_icd: ""
        },
        listLayanan: [],
        listObat: [],
    },
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_REPORT_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_REPORT_LISTDATA_ICD_PASIEN_SUCCESS: {
            return{
                ...state,
                reportICDPasien: action.value
            }
        }
        case types.MODULE_REPORT_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS: {
            return{
                ...state,
                reportKunjunganPasien: action.value
            }
        }
        case types.MODULE_REPORT_HANDLE_STATE_OUTER: {
            return{
                ...state,
                [action.property]: action.value
            }
        }
        default:
            return {
                ...state
            }
    }
}  